import Hint from "./hint";

export default Hint;
